<template>
  <div class="website-layout">
    <Header />
    <div class="side-bar" v-show="!customerServiceVisible">
      <div class="side-button" :class="{ 'side-button--unread-shaking': unreadReminderShaking }">
        <a-button type="primary" class="model-button" :aria-expanded="barvisible ? 'true' : 'false'" aria-controls="customer-service-info" aria-label="在线客服" @click="showDrawer">
          <span class="button-text">在线客服</span>
          <a-icon :type="barvisible ? 'double-right' : 'double-left'" />
        </a-button>
        <span v-if="customerServiceUnread" class="customer-service-unread-badge">{{ customerServiceUnreadLabel }}</span>
      </div>
      <div v-if="barvisible" id="customer-service-info" class="side-right">
        <div class="side-header"><img src="@/assets/images/headset.png" alt="" />在线客服<a-button type="link" icon="close" aria-label="收起客服面板" @click="showDrawer" /></div>
        <div class="side-details">
          <a-button type="primary" class="side-consult-button" @click="openCustomerService(true)">
            在线咨询
            <span v-if="customerServiceUnread" class="side-consult-button__badge">{{ customerServiceUnreadLabel }} 条新回复</span>
          </a-button>
          <p v-if="customerServiceUnread" class="side-consult-unread-tip">您有 {{ customerServiceUnreadLabel }} 条客服回复</p>
          <h6>热线电话</h6><p>13738681177</p>
          <h6>工作时间</h6><p>周一至周五(9:00-17:00)</p>
          <h6>扫一扫联系我们</h6>
          <img :src="customerServiceLogoURL" alt="联系金电保二维码" class="side-qr" />
        </div>
        <a-button type="primary" icon="to-top" class="side-foot" aria-label="返回顶部" @click="toTop" />
      </div>
    </div>
    <WebCustomerService
      v-if="customerServiceMounted"
      :visible="customerServiceVisible"
      @minimize="minimizeCustomerService"
      @unread-change="setCustomerServiceUnread"
      @request-open="openCustomerService(false)"
    />
    <div class="website-content">
      <route-view />
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './content/header.vue';
  import Footer from './content/footer.vue';
  import RouteView from './RouteView';
  import WebCustomerService from '@/views/customer-service/index.vue';
  import { mapGetters } from 'vuex';
  export default {
    name: 'BasicLayout',
    components: { Header, Footer, RouteView, WebCustomerService },
    data() {
      return {
        customerServiceMounted: false,
        customerServiceVisible: false,
        customerServiceUnread: 0,
        unreadReminderRounds: 0,
        unreadReminderTimer: null,
        unreadReminderShaking: false,
        originalDocumentTitle: '',
        barvisible: false,
        systemConfig: {},
      };
    },
    computed: {
      ...mapGetters(['getToken']),
      customerServiceLogoURL() {
        const base = String(this.systemConfig.public_file_base_url || '').replace(/\/$/, '');
        return base
          ? `${base}/public/system/legacy/static/jdblogo.jpg`
          : 'https://files.jdbsk.com/public/system/legacy/static/jdblogo.jpg';
      },
      customerServiceUnreadLabel() {
        return this.customerServiceUnread > 99 ? '99+' : String(this.customerServiceUnread);
      },
    },
    watch: {
      getToken(value) {
        if (value) this.customerServiceMounted = true;
      },
      '$route.query.online_consult'() {
        this.openCustomerServiceFromRoute();
      },
    },
    beforeDestroy() {
      this.stopUnreadReminder();
    },
    mounted() {
      this.originalDocumentTitle = document.title;
      this.loadSystemConfig();
      if (this.getToken) {
        this.$store.dispatch('user/getUserInfoAction').catch(() => {});
        this.customerServiceMounted = true;
      }
      this.openCustomerServiceFromRoute();
    },
    methods: {
      async loadSystemConfig() {
        try {
          this.systemConfig = (await this.$store.dispatch('configs/setLogo')) || {};
        } catch (_) {
          this.systemConfig = {};
        }
      },
      toTop() {
        window.scrollTo(0, 0);
      },
      showDrawer() {
        this.barvisible = !this.barvisible;
      },
      openCustomerService(requestNotification = false) {
        if (requestNotification) this.requestCustomerServiceNotification();
        this.customerServiceMounted = true;
        this.customerServiceVisible = true;
        this.barvisible = false;
      },
      // 浏览器权限仅在用户点击客服入口时申请；拒绝后不重复打扰。
      requestCustomerServiceNotification() {
        if (typeof window === 'undefined' || !('Notification' in window)) return;
        if (window.Notification.permission !== 'default') return;
        window.Notification.requestPermission().catch(() => { /* 浏览器自行处理 */ });
      },
      minimizeCustomerService() {
        this.customerServiceVisible = false;
      },
      setCustomerServiceUnread(count) {
        const previous = this.customerServiceUnread;
        this.customerServiceUnread = Math.max(0, Number(count) || 0);
        if (!this.customerServiceUnread) this.stopUnreadReminder();
        else if (this.customerServiceUnread > previous) this.startUnreadReminder();
        document.title = this.customerServiceUnread
          ? `(${this.customerServiceUnreadLabel}) ${this.originalDocumentTitle}`
          : this.originalDocumentTitle;
      },
      startUnreadReminder() {
        this.stopUnreadReminder();
        this.unreadReminderRounds = 0;
        this.runUnreadReminder();
      },
      runUnreadReminder() {
        if (!this.customerServiceUnread) return;
        this.unreadReminderRounds += 1;
        this.unreadReminderShaking = false;
        this.$nextTick(() => {
          if (!this.customerServiceUnread) return;
          this.unreadReminderShaking = true;
          window.setTimeout(() => { this.unreadReminderShaking = false; }, 800);
        });
        if (this.unreadReminderRounds < 5) {
          this.unreadReminderTimer = window.setTimeout(() => this.runUnreadReminder(), 60000);
        }
      },
      stopUnreadReminder() {
        if (this.unreadReminderTimer) window.clearTimeout(this.unreadReminderTimer);
        this.unreadReminderTimer = null;
        this.unreadReminderRounds = 0;
        this.unreadReminderShaking = false;
      },
      openCustomerServiceFromRoute() {
        if (this.$route.query.online_consult !== '1') return;
        this.openCustomerService();
        const query = { ...this.$route.query };
        delete query.online_consult;
        this.$router.replace({ path: this.$route.path, query });
      },
    },
  };
</script>

<style lang="less" scoped>
.website-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", "PingFang SC", "Microsoft YaHei", sans-serif;
}
.website-content { flex: 1; min-width: 0; }
.side-bar { display: flex; align-items: center; position: fixed; z-index: 1000; right: 0; top: 50%; transform: translateY(-50%); }
.model-button.ant-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 40px;
  height: 120px;
  padding: 6px 10px;
  border-color: #415695;
  border-radius: 4px 0 0 4px;
  background: #415695;
  color: #fff;
}
.model-button.ant-btn:hover, .model-button.ant-btn:focus { border-color: #415695; background: #415695; color: #fff; }
.model-button.ant-btn:focus-visible { outline: 2px solid #415695 !important; outline-offset: 3px; }
.model-button .button-text { display: block; width: 18px; margin: 0; font-size: 16px; font-weight: 700; line-height: 21px; white-space: normal; }
.model-button .anticon { margin: 0; }
.side-button { position: relative; }
.customer-service-unread-badge {
  position: absolute;
  top: -10px;
  left: -10px;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border: 2px solid #fff;
  border-radius: 12px;
  background: #ef5b5b;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
  text-align: center;
  pointer-events: none;
}
.side-right { display: flex; flex-direction: column; justify-content: space-between; width: 180px; max-height: ~"calc(100vh - 48px)"; overflow-y: auto; border: 1px solid #415695; background: #fff; }
.side-header { display: flex; align-items: center; justify-content: center; min-height: 35px; background: #415695; color: #fff; font-size: 16px; font-weight: bold; }
.side-header > img { width: 20px; height: 20px; margin-right: 8px; }
.side-header .ant-btn { width: 28px; padding: 0; margin-left: 10px; color: #fff; font-size: 13px; }
.side-details { display: flex; flex-direction: column; align-items: center; padding: 8px 0 12px; }
.side-details h6 { margin: 10px 0 2px; }
.side-details p { font-size: 12px; }
.side-qr { width: 120px; margin-top: 8px; }
.side-foot.ant-btn { flex-shrink: 0; width: 100%; height: 35px; padding: 0; border: 0; border-radius: 0; background: #415695; color: #fff; font-size: 20px; }
.side-consult-button { position: relative; width: 120px; margin: 0 auto 4px; border-color: #415695; background: #415695; }
.side-consult-button__badge { position: absolute; top: -10px; right: -28px; min-width: 52px; height: 20px; padding: 0 6px; border: 2px solid #fff; border-radius: 10px; background: #ef5b5b; color: #fff; font-size: 11px; font-weight: bold; line-height: 16px; }
.side-details .side-consult-unread-tip { color: #d64b4b; font-size: 12px; font-weight: 600; }
.side-button--unread-shaking .model-button { animation: customer-service-unread-shake .8s ease-in-out; }
@keyframes customer-service-unread-shake {
  0%, 100% { transform: translateX(0); }
  16%, 50%, 84% { transform: translateX(-5px); }
  33%, 67% { transform: translateX(5px); }
}
@media (max-width: 640px) {
  .side-bar { top: auto; bottom: 24px; transform: none; align-items: flex-end; }
}
@media (prefers-reduced-motion: reduce) {
  .side-button--unread-shaking .model-button { animation: none; }
}
</style>
